import { Stack } from '@mui/material';
import { IFilteredCategories } from '..';
import { SelectedFilter } from './SelectedFilter';
import { useContext } from 'react';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { ENTITLEMENT_TYPES } from 'Enum/CompassRights';
import { useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IFilters {
  filteredCategories: IFilteredCategories[];
}

export const Filters = ({ filteredCategories }: IFilters) => {
  const { entitlementTypes, removeEntitlementType } =
    useContext(EntitlementsContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CompassRights);

  return (
    <Stack direction='row' gap='12px' flexWrap='wrap'>
      {filteredCategories.map((category: IFilteredCategories) => {
        if (category.id === 0) return null;
        return (
          <SelectedFilter
            key={category.mainCategory + category.id}
            id={category.id}
            name={category.name}
            mainCategory={{
              id: category.mainCategoryID,
              name: category.mainCategory,
            }}
          />
        );
      })}
      {entitlementTypes.length > 0 &&
        entitlementTypes.map((type) => (
          <SelectedFilter
            key={type}
            id={type}
            name={
              type === ENTITLEMENT_TYPES.automatic
                ? dictionary.entitlements.automatic
                : dictionary.entitlements.singleUse
            }
            mainCategory={{
              id: 999 + type,
              name: dictionary.entitlements.type,
            }}
            onClick={() => removeEntitlementType(type)}
          />
        ))}
    </Stack>
  );
};
